import styled from 'styled-components';

export const Section03_Styled = styled.section`
  padding: 32px 0 0;
  background-color: white;

  @media screen and (min-width: 992px) {
    padding: 64px 0 0;
  }
`;

export const Title = styled.h2`
  line-height: 1.3;
  text-align: center;
  font-size: 20px;

  @media screen and (min-width: 992px) {
    grid-column: 3 / 11;
    font-size: 30px;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  text-align: center;
  margin-top: 28px;
  padding-bottom: 46px;
  line-height: 1.5;
  color: #4f4f4f;

  @media screen and (min-width: 992px) {
    padding-bottom: 75px;
    font-size: 18px;
    grid-column: 3 / 11;
  }
`;

export const Separator = styled.hr`
  border: none;
  height: 1px;
  width: 100%;
  display: block;
  background: black;
  opacity: 0.1;
  margin: 0;

  &:after {
    content: '';
    visibility: hidden;
    display: block;
    height: 0;
    clear: both;
  }

  &:before {
    content: '';
    visibility: hidden;
    display: block;
    height: 0;
    clear: both;
  }
`;

export const Item = styled.div`
  padding: 60px 0;
  align-self: stretch;
  text-align: center;
  grid-column: 1 / 13;

  @media screen and (min-width: 992px) {
    padding: 85px 45px 75px;
  }

  img {
    margin-bottom: 25px;
  }

  p {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 1.5;
    margin-top: 30px;
  }

  &:nth-child(2n) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  &:nth-child(1) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  @media screen and (min-width: 992px) {
    &:nth-child(2n) {
      grid-column: 5 / 9;
    }

    &:nth-child(2n + 1) {
      grid-column: 9 / 13;
    }

    &:nth-child(1) {
      grid-column: 1 / 5;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Section-03/styled.js